// src/pages/PrivacyPage.tsx

import { StaticPageLayout } from '@/components/StaticPageLayout';

export const PrivacyPage = () => {
  return (
    <StaticPageLayout title="sidepocket プライバシーポリシー">
      <p className="text-gray-700 leading-relaxed mb-6">
        sidepocket運営事務局（以下、「当方」といいます。）は、本ウェブサイト上で提供するサービス「sidepocket」（以下、「本サービス」といいます。）における、ユーザーの個人情報の取扱いについて、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
      </p>

      <Section title="第1条（個人情報）">
        <p>
          「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
        </p>
      </Section>

      <Section title="第2条（個人情報の収集方法）">
        <p>
          当方は、ユーザーが利用登録をする際にメールアドレスなどの個人情報をお尋ねすることがあります。本サービスは、認証にFirebase Authenticationを利用しており、ユーザーがGoogleアカウントを用いて登録する場合、Googleアカウントのプロフィール情報（氏名、メールアドレス、プロフィール写真など）を取得します。
        </p>
        <p>また、ユーザーが本サービスを利用するにあたり、以下の情報を収集します。</p>
        <ul className="list-disc list-inside pl-4 space-y-2 mt-3">
          <li><strong>プロジェクト情報：</strong>プロジェクト名、契約形態、単価など</li>
          <li><strong>稼働時間の記録：</strong>開始時刻、終了時刻など</li>
          <li><strong>Googleカレンダー連携機能を利用する場合：</strong>ユーザーのGoogleカレンダー上の予定情報</li>
        </ul>
      </Section>

      <Section title="第3条（個人情報を収集・利用する目的）">
        <p>当方が個人情報を収集・利用する目的は、以下のとおりです。</p>
        <ul className="list-disc list-inside pl-4 space-y-2 mt-3">
          <li>本サービスの提供・運営のため</li>
          <li>ユーザーからのお問い合わせに回答するため（本人確認を行うことを含む）</li>
          <li>メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
          <li>利用規約に違反したユーザーや、不正・不当な目的でサービスを利用しようとするユーザーの特定をし、ご利用をお断りするため</li>
          <li>ユーザーにご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため</li>
          <li>当方の新機能、更新情報、キャンペーン等のご案内のため</li>
          <li>本サービスおよび当方が提供する他のサービスに関連した、アンケートや個別のニーズに合わせた情報提供のため</li>
          <li>上記の利用目的に付随する目的</li>
        </ul>
      </Section>

      <Section title="第4条（Googleカレンダー連携について）">
        <p>本サービスは、ユーザーの利便性向上のため、Google Calendar APIを利用した機能を提供します。</p>
        <ol className="list-decimal list-inside pl-4 space-y-3 mt-3">
          <li>
            <strong>取得する情報：</strong>ユーザーが認証したGoogleアカウントのカレンダー情報（予定のタイトル、開始時刻、終了時刻）。取得する情報はユーザーがOAuth認証時に許可した範囲に限定されます。
          </li>
          <li>
            <strong>利用目的：</strong>取得したカレンダー情報を本サービスの稼働実績として取り込むためにのみ利用します。
          </li>
          <li>
            <strong>情報の取扱い：</strong>取得した情報は、本サービスの機能提供の目的以外で利用したり、第三者に提供したりすることはありません。当方は、Google API Services User Data Policyに従ってこれを取り扱います。Google社のプライバシーポリシーについては、
            <a 
              href="https://policies.google.com/privacy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              こちら
            </a>
            をご確認ください。
          </li>
        </ol>
      </Section>

      <Section title="第5条（広告配信およびCookie等の利用）">
        <p>
          本サービスでは、利便性向上や不正利用防止のため、アクセスログやCookie等の情報を収集する場合があります。
        </p>
        
        <h3 className="font-semibold text-gray-800 mt-4 mb-2">1. Google Adsenseについて</h3>
        <p>
          本サービスでは、第三者配信の広告サービス「Google Adsense」を利用しています。広告配信事業者は、ユーザーの興味に応じた広告を表示するためにCookie（クッキー）を使用することがあります。
        </p>
        <p>
          Cookieを使用することで、ユーザーがそのサイトや他のサイトに過去にアクセスした際の情報に基づいて広告を配信することが可能になります。
        </p>
        <p>
          ユーザーは、
          <a 
            href="https://www.google.com/settings/ads" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            Google広告設定
          </a>
          でパーソナライズ広告を無効にすることができます。また、
          <a 
            href="https://www.aboutads.info/choices/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            www.aboutads.info
          </a>
          にアクセスすることで、パーソナライズ広告に使用される第三者配信事業者のCookieを無効にすることができます。
        </p>
        <p>
          Google社の広告におけるCookieの利用については、
          <a 
            href="https://policies.google.com/technologies/ads" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            Google広告に関するポリシー
          </a>
          をご確認ください。
        </p>

        <h3 className="font-semibold text-gray-800 mt-4 mb-2">2. Google Analyticsについて</h3>
        <p>
          本サービスでは、アクセス解析ツール「Google Analytics」を利用しています。Google Analyticsはトラフィックデータの収集のためにCookieを使用しています。このトラフィックデータは匿名で収集されており、個人を特定するものではありません。
        </p>
        <p>
          この機能はCookieを無効にすることで収集を拒否することができますので、お使いのブラウザの設定をご確認ください。Google Analyticsの利用規約については、
          <a 
            href="https://marketingplatform.google.com/about/analytics/terms/jp/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            こちら
          </a>
          をご確認ください。
        </p>
      </Section>


      <Section title="第6条（個人情報の第三者提供）">
        <p>
          当方は、次に掲げる場合を除いて、あらかじめユーザーの同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
        </p>
        <ol className="list-decimal list-inside pl-4 space-y-2 mt-3">
          <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
          <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
          <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
        </ol>
      </Section>

      <Section title="第7条（業務委託）">
        <p>
          当方は、サービス運営に必要な範囲で、業務の一部を外部業者に委託する場合があります。この場合、当方は委託先に対して適切な監督を行い、個人情報の安全管理を確保します。
        </p>
      </Section>

      <Section title="第8条（個人情報の開示）">
        <p>
          当方は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。
        </p>
        <ol className="list-decimal list-inside pl-4 space-y-2 mt-3">
          <li>本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
          <li>当方の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
          <li>その他法令に違反することとなる場合</li>
        </ol>
      </Section>

      <Section title="第9条（個人情報の訂正および削除）">
        <ol className="list-decimal list-inside pl-4 space-y-2">
          <li>
            ユーザーは、当方の保有する自己の個人情報が誤った情報である場合には、当方が定める手続きにより、当方に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。
          </li>
          <li>
            当方は、ユーザーから前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
          </li>
        </ol>
      </Section>

      <Section title="第10条（個人情報の保存期間）">
        <p>
          当方は、ユーザーが本サービスを退会した場合、合理的な期間内に関連する個人情報を削除または匿名化します。ただし、法令に基づき保存が必要な場合を除きます。
        </p>
      </Section>

      <Section title="第11条（プライバシーポリシーの変更）">
        <p>
          本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、ユーザーに通知することなく、変更することができるものとします。当方が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。
        </p>
      </Section>

      <Section title="第12条（ダイレクトメールの停止）">
        <p>
          ユーザーは、当方が別途定める手続きに従い、いつでも当方からのメールマガジンやキャンペーン情報の配信停止を求めることができます。配信停止の手続きについては、お送りするメールマガジンに記載のリンクから行うことができます。
        </p>
      </Section>

      <Section title="第13条（お問い合わせ窓口）">
        <p>本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。</p>
        <div className="pl-4 mt-3">
          <p className="font-semibold">sidepocket運営事務局</p>
          <p>連絡先：contact.sidepocket@seaside-lab.com</p>
        </div>
      </Section>

      <div className="mt-10 pt-6 border-t border-gray-200">
        <p className="text-gray-600">以上</p>
        <p className="text-gray-600">改定日：2025年7月31日</p>
      </div>
    </StaticPageLayout>
  );
};

// セクションコンポーネント
const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <section className="mt-10">
    <h2 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
      {title}
    </h2>
    <div className="text-gray-700 leading-relaxed space-y-3 pl-4">
      {children}
    </div>
  </section>
);
